import * as LJS from "../../../lib/littlejs.esm";
import { tilesize, tilesheets } from '../../const/tiles.ts';
import Globals from "../../globals.ts";
/**
 * Key entity that Chip can collect to unlock LockedDoors.
 */
class Key extends LJS.EngineObject {
    constructor(pos) {
        // Use a tile from the assets tilesheet for the key, assuming tile index 0 for key
        const keyTile = LJS.tile(0, tilesize, tilesheets.ASSETS);
        super(pos, LJS.vec2(0.5, 0.5), keyTile);
        this.collected = false;
        this.setCollision(false, false, false, false);
        this.mass = 0; // Not affected by gravity
    }
    update() {
        if (this.collected) {
            this.destroy();
            return;
        }
        // Check if Rex or Chip is close enough to collect the key
        if (Globals.rex && this.pos.distance(Globals.rex.pos) < 0.5) {
            this.collectByRex();
        }
        else if (Globals.chip && this.pos.distance(Globals.chip.pos) < 0.5) {
            this.collectByChip();
        }
    }
    /**
     * Collect the key and add it to inventory.
     */
    collect() {
        this.collected = true;
        Globals.keys += 1;
        console.log(`Key collected. Total keys: ${Globals.keys}`);
    }
    /**
     * Collect the key by Rex.
     */
    collectByRex() {
        this.collected = true;
        Globals.rexHasKey = true;
        console.log(`Key collected by Rex.`);
    }
    /**
     * Collect the key by Chip.
     */
    collectByChip() {
        this.collected = true;
        Globals.keys += 1;
        console.log(`Key collected by Chip. Total keys: ${Globals.keys}`);
    }
}
export default Key;
